import { useState, useEffect } from "react";

const FlashFriday = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const today = new Date();

    const startDate = new Date();
    const endDate = new Date(2025, 8, 30, 23, 59, 59);

    setShowBanner(today >= startDate && today <= endDate);
  }, []);

  if (!showBanner) return null;

  return (
    <div
      className="flex align-items-center justify-content-center mx-auto py-3"
      style={{ backgroundColor: "#0C1239" }}
    >
      <div className="relative flex flex-col items-center gap-2 text-center">
        <div className="flex items-center gap-3">
          <p
            className="text-white fw-bold px-3 py-2 rounded-10"
            style={{ backgroundColor: "#2E3B8F" }}
          >
            NEW
          </p>
          <h4 className="text-white position-relative m-0">
            Flash Friday Deal! Get 10% off Shortlet Bookings every Friday 🎉
          </h4>
        </div>

        <p
          className="fw-bold px-3 py-1 rounded"
          style={{
            backgroundColor: "#daf1ee",
            fontSize: "14px",
          }}
        >
          Use Code: <span style={{ fontWeight: "900" }}>KRNT01F</span>
        </p>
      </div>
    </div>
  );
};

export default FlashFriday;
